import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
// Preview is compiled separately; it cannot change accounts or launch checkout.
const App = process.env.REACT_APP_BILLING_PREVIEW === 'true'
  ? require('./SubscriptionPreview').default
  : require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production' && process.env.REACT_APP_BILLING_PREVIEW !== 'true') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(error => {
      console.log('Service worker registration failed:', error)
    })
  })
}
